module.exports = __webpack_public_path__ + "img/Progress-Report-Process-5-mobile.3e76bd6b.png";